import send from '../../util/request';

export function changePasswordApi(params = {}) {
  return send({ url: '/ipp/v3/public/change-password', method: 'POST', data: params });
}